export default __webpack_public_path__ + "static/media/0-icon-alert-circle-outline-thick.9896fddb.svg";